import SURVEY from "./survey.svg";
import CONTACT_US from "./contact-us.svg";
import MISSED_THINGS from "./missed-things.svg";

import Cinema from "./Cinema.svg";
import Parking from "./Parking.svg";
import FoodCourt from "./FoodCourt.svg";
import Commercial from "./Commercial.svg";
import HyperMarket from "./HyperMarket.svg";
import Kindergarten from "./Kindergarten.svg";

export const SHAPES = {
  SURVEY,
  CONTACT_US,
  MISSED_THINGS,
  Cinema,
  Parking,
  FoodCourt,
  Commercial,
  HyperMarket,
  Kindergarten,
};
